import { render, staticRenderFns } from "./OrdersToday.vue?vue&type=template&id=5c23fa95"
import script from "./OrdersToday.vue?vue&type=script&lang=js"
export * from "./OrdersToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports